;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var View = APP.module('View');
	View.Notifications = Marionette.ItemView.extend({
		tagName: 'div',
		initialize: function() {
			this.user         = this.getOption('model');
			this.fields       = this.getOption('fields');
			this.formTemplate = this.getOption('form_template');
			this.errors       = true;

			this.showPreloader();
			this.setTemplateData();

			$.when.call(null, this.user.getProfile() )
				.done(_.bind(this.setTemplateData, this))
				.done(_.bind(this.customInitAdder, this))
				.done(_.bind(this.render,  this))
				.done(_.bind(this.hideOtherNotifications,  this))
				.done(_.bind(this.hidePreloader,  this));

			return this;
		},
		ui: {
			'submitForm'     : '#js-account-notifications',
			'update_response': '.update-response',
			'other_settings' : '.other-settings'
		},
		events: {
			'click @ui.submitForm': 'setNotifications'
		},
		render: function () {

			if(this.errors ) return;

			this.$el.html(this.form.render().el);
			this.showCurrentTab();

			return this;
		},
		onShow: function(){
			this.hideOtherNotifications(null, null, true);
		},
		showCurrentTab: function(){
			var _this = this;
			setTimeout(function(){
				$(_this.$el).find('.panel-body').addClass('open-tab');
			}, 10);
		},
		setNotifications:function(){

			if($(this.ui.submitForm).hasClass('success-update')){
				return;
			}

			this.showPreloader();

			if (this.errors) {
				this.hidePreloader();
				return;
			}

			var notifications = this.getNotificationsOnly();

			this.user.set(notifications);

			$.when.call(null,this.user.update(notifications)).done(_.bind(function(response){
				if (response.errors.length) {
					this.showErrors(response.errors);
				}
				else {

					var updated_data = _.extend(this.user.toJSON(), response.result.user);
					this.user.set(updated_data);

					APP.vent.trigger('user:get:profile', updated_data);

					this.successUpdateFinish();
				}

				this.hidePreloader();

			}, this));
			return this;
		},

		getNotificationsOnly: function(){

			var notifications =  _.omit(this.form.getValue(), function(value,key){

				return !_.isNumber(value);
			});

			if(notifications.disable_notification !== 'undefined'){

				notifications.disable_notifications = + !notifications.disable_notifications;
			}

			return notifications;
		},

		setTemplateData: function(){
			
			var template = JST[this.formTemplate+'notifications'];

			template =  _.isFunction(template) ? template :  JST.notifications;

			this.form = new Backbone.Form({
				template: template,
				templateData: {
					fields_global: this.fields.global,
					fields_other: this.fields.others
				},
				model: this.user
			});

			this.errors = false;

			return this;
		},

		customInitAdder: function(){

			this.listenTo(this.form, 'change' , this.clearAll);
			this.listenTo(this.form, 'disable_notifications:change' , this.hideOtherNotifications);

			return this;
		},

		hideOtherNotifications: function(model, editor, is_first){

			var value = 0;

			if(is_first && !_.isArray(is_first)){
				value = this.user.get('disable_notifications');
			}
			else {
				value = !editor.getValue();
			}

			value && $(this.ui.other_settings).hide() ||  $(this.ui.other_settings).show();
			$(this.ui.other_settings).show();
			return this;
		},

		updateUser: function(){

			var updated_data = this.getNotificationsOnly();

			this.user.set(updated_data);

			return updated_data;

		},

		successUpdateFinish: function(){
			$(this.ui.update_response).html('Thank you, your account has been updated');
			$(this.ui.submitForm).addClass('success-update').html('Updated');
		},

		clearAll: function(){
			$(this.ui.update_response).html('');
			$(this.ui.submitForm).removeClass('success-update').html('Update');
		}

	});

}(window, APP, Backbone, Marionette, $, _));
